<app-customer-list [routeIds]="selectedRouteIds" (customerSelected)="handleCustomerSelected($event)">
</app-customer-list>
